var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverageDfcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.6904 1.20312H0.310547V41.758H59.6904V1.20312Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54.1557 7.07812H5.84668V35.878H54.1557V7.07812Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.3418 48.8359H50.8638",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.7275 41.6094V48.8303",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M53.4042 15.7172C53.3916 15.6215 53.3027 15.5543 53.2079 15.5669L48.2437 16.2336L44.8033 15.315L46.0127 13.3024L49.3524 11.8699L49.4329 11.8355C49.5218 11.7977 49.5629 11.6944 49.5243 11.6063C49.4866 11.5173 49.3834 11.4761 49.2954 11.5148L45.772 13.027L45.205 13.9716L42.5749 13.1034L41.3722 10.9522L41.3001 10.8237C41.2531 10.7398 41.1466 10.7095 41.0627 10.7566C40.9788 10.8036 40.9487 10.9102 40.9956 10.9942L43.5109 15.493L42.9456 15.3125L40.2114 12.9506L37.6064 12.8448C37.5108 12.8397 37.4286 12.9161 37.4253 13.0127C37.4211 13.1092 37.4966 13.1907 37.593 13.194L40.0764 13.2948L41.1885 14.2554L41.8955 16.6484L36.5421 17.9884C36.4482 18.0119 36.392 18.1068 36.4155 18.2C36.4356 18.2789 36.5069 18.3327 36.5849 18.3327C36.5992 18.3327 36.6134 18.331 36.6277 18.3276L40.526 17.352L42.278 18.3411L38.6582 21.7383C38.5877 21.8046 38.5844 21.9146 38.6506 21.9851C38.685 22.0221 38.7311 22.0406 38.7781 22.0406C38.8209 22.0406 38.8637 22.0246 38.8972 21.9935L41.2246 19.8088L43.7524 19.5745L43.1133 24.6796L43.1066 24.7341C43.1066 24.7341 43.1066 24.735 43.1066 24.7358L43.0882 24.8802C43.0764 24.976 43.1444 25.0633 43.24 25.075C43.2475 25.0759 43.2542 25.0767 43.2618 25.0767C43.3482 25.0767 43.4237 25.0121 43.4346 24.9239L43.4538 24.7719L43.8816 21.4159L45.7888 21.6652L46.1897 22.4998L46.5654 23.2824C46.6074 23.3697 46.7113 23.4067 46.7986 23.3638C46.8858 23.3219 46.9219 23.2177 46.8799 23.1304L46.0622 21.4259L45.4625 20.1774L45.6613 17.8717L48.9247 19.9381L50.743 21.0892C50.8243 21.1405 50.9325 21.1169 50.9837 21.0347C51.0357 20.9532 51.0114 20.8449 50.9292 20.7937L49.8296 20.0976L48.8366 19.4687L47.4528 16.6971L48.892 16.5039L53.0335 15.9481L53.2557 15.9179C53.3513 15.9053 53.4184 15.8171 53.4058 15.7214L53.4042 15.7172ZM45.0205 14.2772L44.0938 15.8196L42.8265 13.5534L45.0197 14.2772H45.0205ZM44.2137 18.7978L44.3269 18.6182L45.6068 21.2849L43.9244 21.0649L44.2137 18.7978ZM44.368 17.8969L43.8766 18.6761L43.8078 19.2143L41.6372 19.415L42.8609 18.2663L41.0158 17.2252L42.3317 16.896L41.675 14.6743L42.7695 15.6198L43.7583 15.9355L44.082 16.514L44.6154 15.6257L47.3412 16.3536L44.9207 16.6786L45.3309 17.5946L45.1623 19.5527L44.3672 17.8952L44.368 17.8969ZM48.2638 19.1035L45.6479 17.4469L45.4323 16.9649L47.0854 16.7432L48.2646 19.1043L48.2638 19.1035Z",
    fill: "#005FC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.6211 38.7969H49.8146",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageDfcIcon);
export default __webpack_public_path__ + "static/media/coverage-dfc-icon.b0ac92b7.svg";
export { ForwardRef as ReactComponent };